import React, { useState, useEffect, useRef } from "react";
import ProfileCard from "./profileCard";
import DoctorProfileDetails from "./doctorProfileDetails";
import "./doctorProfile.css";
import strings from "../../Utils/strings";
import AppDialog from "../../Widgets/appDialog/appDialog";
import { useLocation, useNavigate } from "react-router";
import { Calendar } from "react-multi-date-picker";
import EditDoctorProfile from "../editDoctorProfile/editDoctorProfile";
import utils from "../../Utils";
import authService from "../../Services/authService";
import clinicService from "../../Services/clinicService";
import moment from "moment";
import toast from "react-hot-toast";
import { format } from "date-fns";
import Widgets from "../../Widgets";
import validations from "../../Utils/validations";
import "./doctorProfile.css";
import EditDoctorProfileView from "../editDoctorProfile/editDoctorProfileView";
import OffCanvas from "../common/offCanvas";
import constants from "../../Utils/constants";
import { t } from "../../Utils/translate";
import VitalSignsNotification from "../vitalSigns/vitalSignsNotification/vitalSignsNotification";
import DoctorTiming from "../manageClinic/doctorTiming/doctorTiming.jsx";
import Component from "..";
import { useDispatch, useSelector } from "react-redux";
import { deleteDoctor } from "../../modules/AddDoctor/AddDoctorThunk.js";
import { resetDeleteDoctor } from "../../modules/AddDoctor/AddDoctorSlice.js";
import EditDocNew from "../editDoctorProfile/EditDocNew.jsx";

function DoctorProfileView() {
  const state = useLocation();
   const dispatch = useDispatch();
    const { deleteDoctorErr, deleteDoctorSuccess } = useSelector(
      (state) => state.addDoctor,
    );
  const nav = useNavigate();
  const [popup, setPopup] = useState();
  const [holidayList, setHolidayList] = useState([]);
  const [selectedDates, setSelectedDates] = useState("");
  const [holidayExist, setHolidayExist] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDoctorLogin, setIsDoctorLogin] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [deletedDoctorModal, setDeletedDoctorModal] = useState(false);
  const [isCalender, setIsCalender] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [oldPasswordType, setOldPasswordType] = useState("password");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [reenterPassword, setReenterPassword] = useState("");
  const [reenterPasswordTouched, setReenterPasswordTouched] = useState(false);
  const [passwordOneType, setPasswordOneType] = useState("password");
  const [passwordTwoType, setPasswordTwoType] = useState("password");
  const [passwordOneErr, setPasswordOneErr] = useState("");
  const [passwordTwoErr, setPasswordTwoErr] = useState("");
  const [error, setError] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [forgot, setForgot] = useState(false);
  const [isSetAsWorkingDay, setIsSetAsWorkingDay] = useState(false);
  const [selectedLeaveId, setSelectedLeaveId] = useState("");
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [doctorId, setDoctorId] = useState(null);
  const [randomRefresherNumber, setRandomRefresherNumber] = useState(0);
  const [cancelAppointmentPopUp, setCancelAppointmentPopUp] = useState(false);
  const [showDoctorTiming, setShowDoctorTiming] = useState(false);
  const [isPasswordChange, setIsPasswordChange] = useState(false);
  const [doctorInfo, setDoctorInfo] = useState({});
  const isFetched = useRef(false);
  const [clicked, setClicked] = useState(false);
  const [leaveTitle, setLeaveTitle] = useState("");
  const [lastSelectedDate, setLastSelectedDate] = useState(null);
  const [dateList, setDateList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [delDoc, setDelDoc] = useState(false)

  const [isLangEn, setIsLangEn] = useState(true);

  useEffect(() => {
    if(deleteDoctorErr){
      toast.error(deleteDoctorErr)
      setIsLoading(false)
    }
    if(deleteDoctorSuccess){
      toast.success(t('docDecSuccss'))
      nav(strings.navigation.manageDoctor)
    }
    setDelDoc(false)
    dispatch(resetDeleteDoctor())
  }, [deleteDoctorSuccess, deleteDoctorErr])

  const handleDelDoc = () =>{
    setDelDoc(true)
  }
  
  const delDocPositive = () =>{
    setIsLoading(true)
    dispatch(deleteDoctor({_id: doctorId}))
  }
  

  useEffect(() => {
    const language = localStorage.getItem("i18nextLng");
    if (language) {
      let langCode;
      switch (language) {
        case "en-US":
          langCode = "en";
          break;
        case "vietnam":
          langCode = "vietnam";
          break;
        case "en":
          langCode = "en";
          break;
        default:
          langCode = "en";
      }
      if (langCode !== "en") {
        setIsLangEn(false);
      }
    }
  }, []);

  useEffect(() => {
    setIsDoctorLogin(authService.getIsDoctorLogin() === "true");

  }, []);
  console.log(isDoctorLogin)

  useEffect(() => {
    getDoctorProfile();
    if (!isFetched.current) {
      isFetched.current = true;
      getDoctorAllHolidaysList();
    }
  }, [isDoctorLogin, refresh]);

  const togglePassword = () => {
    if (oldPasswordType === strings.doctorProfile.password) {
      setOldPasswordType(strings.doctorProfile.text);
      return;
    }
    setOldPasswordType(strings.doctorProfile.password);
  };

  const togglePasswordOne = () => {
    if (passwordOneType === strings.doctorProfile.password) {
      setPasswordOneType(strings.doctorProfile.text);
      return;
    }
    setPasswordOneType(strings.doctorProfile.password);
  };

  const togglePasswordTwo = () => {
    if (passwordTwoType === strings.doctorProfile.password) {
      setPasswordTwoType(strings.doctorProfile.text);
      return;
    }
    setPasswordTwoType(strings.doctorProfile.password);
  };

  function oldPasswordChange(event) {
    const value = event.target.value;
    setOldPassword(value);
    if (!value) {
      setPasswordErr(t("oldPassword"));
    } else {
      setPasswordErr("");
    }
  }

  const passwordHandlerOne = (e) => {
    let item = e.target.value.trim();
    setNewPassword(item);
    setError("");
    if (item === "") {
      setPasswordOneErr(t("newPassword"));
      setIsValid(false);
    } else {
      const isValid = validations.passwordValidator(item, oldPassword);
      if (isValid.status) {
        setPasswordOneErr("");
        setIsValid(true);
      } else {
        setPasswordOneErr(isValid.message);
        setIsValid(false);
      }
    }
    if (item !== reenterPassword && reenterPassword !== "") {
      setPasswordTwoErr(t("mismatchPassword"));
      setIsValid(false);
    } else {
      setPasswordTwoErr("");
      setIsValid(true);
    }
    setNewPassword(item);
  };

  function passwordHandlerTwo(e) {
    let item = e.target.value.trim();
    setReenterPassword(item);
    setError("");
    if (item === "") {
      setPasswordTwoErr(t("confirmPassword"));
      setIsValid(false);
    } else {
      const isValid = validations.passwordValidator(item, oldPassword);
      if (isValid.status) {
        setPasswordTwoErr("");
        setIsValid(true);
      } else {
        setPasswordTwoErr(isValid.message);
        setIsValid(false);
      }
      setReenterPassword(item);
      if (item !== newPassword) {
        setPasswordTwoErr(t("mismatchPassword"));
        setReenterPasswordTouched(true);
        setIsValid(false);
      } else {
        setPasswordTwoErr("");
        setIsValid(true);
      }
      setReenterPassword(item);
    }
  }

  const getDoctorProfile = async () => {
    try {
      const docId = isDoctorLogin ? authService.getDoctorID : state.state.doctorId;
      setIsLoading(true);
      let doctorDetails;
      if (authService.getIsDoctorLogin() === "true") {
        doctorDetails = await clinicService.getDoctorDetials(docId);
      } else if (authService.getIsDoctorLogin() === "false") {
        doctorDetails = await clinicService.getDoctorProfileView(docId);
      }
      setIsLoading(false);
      if (doctorDetails) {
        setDoctorInfo(doctorDetails.data.doctor);
        setDoctorId(doctorDetails.data.doctor._id);
        doctorDetails.doctorDetails.map((details) => {
          return setIsCalender(details.isCalender);
        });
      }
    } catch {}
  };
  const getDoctorAllHolidaysList = async () => {
    try {
      const docId = authService.getDoctorId() ? authService.getDoctorId() : state.state.doctorId;
      let body = {
        clinicId: authService.getID(),
        doctorId: docId,
        date: utils.constants.dateTosend,
      };
      let holidayStartDate = [];
      let holidayExist = [];
      let response;

      if (authService.getIsDoctorLogin() === "true") {
        response = await clinicService.getDoctorAllHolidaysListDoc(body);
      } else if (authService.getIsDoctorLogin() === "false") {
        response = await clinicService.getDoctorAllHolidaysList(body);
      }
      if (response && response.allLeaves) {
        setHolidayList(response.allLeaves);
        response.allLeaves.map((dt) => {
          return (
            holidayStartDate.push(dt.leave.startDate),
            holidayExist.push({
              startDate: dt.leave.startDate,
              endDate: dt.leave.endDate,
            })
          );
        });
        setHolidayExist(holidayExist);
        setSelectedDates(holidayStartDate);
      }
    } catch {}
  };

  const handleEditProfileChanges = (isClose) => {
    setIsLoading(isClose);
  };

  function disableButton() {
    let returnValue = false;
    if (newPassword !== reenterPassword) {
      returnValue = true;
    } else if (oldPassword.length > 0 && newPassword.length > 0 && reenterPassword.length > 0 && passwordOneErr == "" && passwordTwoErr == "" && passwordErr == "") {
      returnValue = false;
    } else {
      returnValue = true;
    }
    return returnValue;
  }

  const forgotPasswordForDoctor = async () => {
    try {
      let body = {};
      setIsLoading(true);
      localStorage.clear();
      nav(strings.navigation.forgotPassword);
    } catch {}
  };

  const handleClose = () => {
    setShowEditProfile(false);
  };

  const handleCloseChangePassword = (e) => {
    setChangePassword(e);
    setOldPassword("");
    setNewPassword("");
    setReenterPassword("");
    setPasswordOneErr("");
    setPasswordErr("");
    setPasswordTwoErr("");
    setPasswordOneType(strings.doctorProfile.password);
    setPasswordTwoType(strings.doctorProfile.password);
    setOldPasswordType(strings.doctorProfile.password);
  };

  const handleEditDoctorTimingUpdate = (isEditable) => {
    setRandomRefresherNumber(Math.floor(Math.random() * 10));
    setIsLoading(isEditable);
  };

  const handleDoctorTimingClose = () => {
    setShowDoctorTiming(false);
  };

  const [leaveBtnDisabled, setLeaveBtnDisabled] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  //   const handleSelectedDateChanges = (dates) => {
  //     console.log("First");
  //     const selectedTimestamps = new Set(selectedDates.map((date) => new Date(date).toISOString()));

  //     const filteredNewDates = dates.filter((date) => {
  //         const isoString = new Date(date).toISOString();
  //         return !selectedTimestamps.has(isoString);
  //     });

  //     console.log(filteredNewDates, selectedDates);
  //     if (filteredNewDates.length > 0) {
  //         const formattedDate = new Date(filteredNewDates[0]).toISOString().split("T")[0];
  //         setClicked(true);
  //         setSelectedDate(formattedDate);
  //     }
  // };
  const handleSelectedDateChanges = (dates) => {
    setSelectedDate(dates);
  };

  const createLeave = async () => {
    const newDAte = new Date(selectedDate).toISOString().split("T")[0];
    const body = {
      date: newDAte,
      reason: leaveTitle,
      doctor: doctorId,
    };
    try {
      setIsLoading(true);
      let leaveDetials;
      if (authService.getIsDoctorLogin() === "true") {
        leaveDetials = await clinicService.docLogCreateLeaave(body);
      } else if (authService.getIsDoctorLogin() === "false") {
        leaveDetials = await clinicService.createDoctorLeave(body);
      }
      setIsLoading(false);
      if (leaveDetials.data.leave.isClosed) {
        setPopup(false);
        setLeaveTitle("");
        setSelectedDate("");
        toast.success(t("leaveSuccess"));
      }
    } catch {}
  };
  useEffect(() => {
    if (selectedDate && leaveTitle.length > 0) {
      setLeaveBtnDisabled(true);
    } else {
      setLeaveBtnDisabled(false);
    }
  }, [leaveTitle, selectedDate]);

  useEffect(() => {
    setLeaveTitle("");
    setSelectedDate("");
    if (popup) {
      getLeaveDetials();
    }
  }, [popup]);

  const [leaveDates, setLeaveDates] = useState([]);

  const getLeaveDetials = async () => {
    console.log("getting leave detials 11111");

    try {
      setIsLoading(true);
      let leaveList;
      if (authService.getIsDoctorLogin() === "true") {
        leaveList = await clinicService.docGetLeavelist(doctorId);
      } else if (authService.getIsDoctorLogin() === "false") {
        leaveList = await clinicService.getDocLeaveList(doctorId);
      }
      setIsLoading(false);
      if (leaveList) {
        const leaveDates = leaveList.data.leaves.map((leave) => moment(leave.date, "DD-MM-YYYY").toDate());
        setSelectedDates(leaveDates);
        setLeaveDates(leaveList.data.leaves);
        console.log(leaveDates);
      }
    } catch {}
  };
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const deleteDocLeave = async () => {
    try {
      setIsSetAsWorkingDay(false);
      setIsLoading(true);
      let leaveList;

      if (authService.getIsDoctorLogin() === "true") {
        leaveList = await clinicService.docDelDocLeave(doctorId, selectedLeaveId);
      } else if (authService.getIsDoctorLogin() === "false") {
        leaveList = await clinicService.delDocLeave(doctorId, selectedLeaveId);
      }
      setIsLoading(false);
      if (leaveList) {
        if (leaveList.status == "success") {
          getLeaveDetials();
          toast.success(t("leaveCancel"));
        } else if (leaveList.data.message) {
          toast.error(leaveList.data.message);
        }
      }
    } catch {}
  };

  return (
    <>
      {isLoading ? (
        <Widgets.CircularLoader />
      ) : (
        <div className="doctor-profile">
          {isSetAsWorkingDay ? (
            <AppDialog
              setVisibility={(e) => {
                setIsSetAsWorkingDay(e);
              }}
              widthType={utils.constants.dialogWidthType.small}
              dialogTitle={t("labelLeave")}
              dialogNegativeBtnText={t("noBtn")}
              dialogPositiveBtnText={t("yesBtn")}
              dialogNegativeBtnCall={() => {
                setIsSetAsWorkingDay(false);
              }}
              dialogPositiveBtnCall={() => {
                deleteDocLeave();
              }}
              view={<Component.WarningPop iconClassName="ri-delete-bin-line" warningMsg={t("setAsWorking")} />}
            />
          ) : null}

          {cancelAppointmentPopUp ? (
            <AppDialog
              setVisibility={(e) => {
                setCancelAppointmentPopUp(e);
              }}
              widthType={utils.constants.dialogWidthType.small}
              dialogTitle={t("cancelRemoteAppointment")}
              dialogPositiveBtnText={t("ok")}
              dialogPositiveBtnCall={() => {
                setCancelAppointmentPopUp(false);
              }}
              view={<Component.WarningPop iconClassName="ri-delete-bin-line" warningMsg={t("cancelAppointment")} />}
            />
          ) : null}

          {popup ? (
            <AppDialog
              setVisibility={(e) => {
                setPopup(e);
                getDoctorProfile();
              }}
              dialogTitle={t("labelManageLeave")}
              dialogNegativeBtnText={leaveBtnDisabled ? t("btnCancel") : null}
              dialogPositiveBtnText={leaveBtnDisabled ? t("btnSubmit") : null}
              dialogPositiveBtnCall={() => {
                createLeave();
              }}
              dialogNegativeBtnCall={() => {
                setPopup(false);
              }}
              view={
                <div>
                  <Calendar
                    fixMainPosition
                    value={selectedDate}
                    onChange={handleSelectedDateChanges}
                    format="DD-MM-YYYY"
                    sort
                    mapDays={({ date }) => {
                      const jsDate = date instanceof Date ? date : date.toDate();
                      const isHighlighted = selectedDates.some((selectedDate) => new Date(selectedDate).toDateString() === jsDate.toDateString());
                      if (isHighlighted) {
                        return {
                          disabled: true,
                          style: { color: "white", backgroundColor: "var(--primary-color)", cursor: "not-allowed" },
                        };
                      }

                      return {};
                    }}
                    minDate={tomorrow}
                  />

                  <div>
                    <div className="row calendar-display d-md-flex d-sm-block">
                      {leaveDates &&
                        leaveDates.map((date, index) => {
                          return (
                            <div key={index} className="col-2 display-date text-nowrap doc-leave-date">
                              <button type="button" className="btn btn-danger btn-depart dt-btn me-5">
                                <span className="d-flex display-content">
                                  {date.date}
                                  <i
                                    className="ri-close-line me-2"
                                    onClick={() => {
                                      setIsSetAsWorkingDay(true);
                                      setSelectedLeaveId(date._id);
                                    }}
                                  ></i>
                                </span>
                              </button>
                            </div>
                          );
                        })}
                    </div>
                    {selectedDate ? (
                      <div className="mb-3">
                        <input
                          type="email"
                          className="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          value={leaveTitle}
                          placeholder={t("leaveDetails")}
                          onChange={(e) => {
                            setLeaveTitle(e.target.value);
                          }}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              }
            />
          ) : null}

          {changePassword ? (
            <AppDialog
              setVisibility={handleCloseChangePassword}
              dialogTitle={t("changePassword")}
              dialogNegativeBtnText={t("btnCancel")}
              dialogPositiveBtnText={t("btnConfirm")}
              dialogPositiveBtnCall={() => {
                setIsPasswordChange(true);
              }}
              dialogNegativeBtnCall={(e) => {
                handleCloseChangePassword(e);
              }}
              disablePositiveBtn={disableButton()}
              view={
                <div>
                  <div className="form-group password">
                    <form>
                      <div className="mt-1">
                        <div className="input-group input-group">
                          <input
                            type={oldPasswordType}
                            value={oldPassword}
                            minLength={8}
                            maxLength={16}
                            className="form-control text-control pe-0"
                            placeholder={t("labelOldPassword")}
                            onChange={(e) => {
                              oldPasswordChange(e);
                            }}
                          />
                          <div className="eye-icon" onClick={togglePassword}>
                            {oldPasswordType === "password" ? (
                              <i className="ri-eye-close-line hide-view extend-phone-text-password"></i>
                            ) : (
                              <i className="ri-eye-fill hide-view extend-phone-text-password "></i>
                            )}
                          </div>
                        </div>
                        <div>
                          <span className="d-flex error-container mt-2 mb-1">
                            {passwordErr && passwordErr.length > 0 ? <i className="ri-information-line me-1" /> : null}
                            {passwordErr}
                          </span>
                        </div>
                      </div>

                      <div className="mt-1">
                        <div className="input-group input-group">
                          <input
                            type={passwordOneType}
                            value={newPassword}
                            minLength={8}
                            maxLength={16}
                            className="form-control text-control pe-0"
                            placeholder={t("labelNewPassword")}
                            onChange={(e) => {
                              passwordHandlerOne(e);
                            }}
                          />
                          <div className="eye-icon" onClick={togglePasswordOne}>
                            {passwordOneType === "password" ? (
                              <i className="ri-eye-close-line hide-view extend-phone-text-password"></i>
                            ) : (
                              <i className="ri-eye-fill hide-view extend-phone-text-password "></i>
                            )}
                          </div>
                        </div>
                        <div>
                          <span className="d-flex error-container mt-2 mb-1">
                            {passwordOneErr.length > 0 ? <i className="ri-information-line me-1" /> : null}
                            {passwordOneErr}
                          </span>
                        </div>
                      </div>
                      <div className="mt-1">
                        <div className="input-group input-group">
                          <input
                            type={passwordTwoType}
                            value={reenterPassword}
                            minLength={8}
                            maxLength={16}
                            className="form-control text-control pe-0"
                            placeholder={t("labelRenterPassword")}
                            onChange={(e) => {
                              passwordHandlerTwo(e);
                            }}
                          />
                          <div className="eye-icon" onClick={togglePasswordTwo}>
                            {passwordTwoType === "password" ? (
                              <i className="ri-eye-close-line hide-view extend-phone-text-password"></i>
                            ) : (
                              <i className="ri-eye-fill hide-view extend-phone-text-password "></i>
                            )}
                          </div>
                        </div>
                        <div>
                          <span className="d-flex error-container mt-2">
                            {(passwordOneErr === "" && reenterPassword.length > 0 && passwordTwoErr.length > 0 && newPassword.length > 0) || reenterPasswordTouched ? (
                              passwordTwoErr ? (
                                <i className="ri-information-line me-1" />
                              ) : null
                            ) : null}
                            {(passwordOneErr === "" && reenterPassword.length > 0 && passwordTwoErr.length > 0 && newPassword.length > 0) || reenterPasswordTouched ? passwordTwoErr : null}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end forgot-text-change-password mt-2">
                        <span className="forgot-text-change-password me-1">{t("forgotPassword")}</span>
                        <span
                          className="register mb-3"
                          onClick={() => {
                            setChangePassword(false);
                            setForgot(true);
                          }}
                        >
                          {t("labelForgotPassword")}
                        </span>
                      </div>
                    </form>
                  </div>
                </div>
              }
            />
          ) : null}

          {isPasswordChange ? (
            <AppDialog
              setVisibility={(e) => {
                setIsPasswordChange(e);
              }}
              widthType={utils.constants.dialogWidthType.small}
              dialogTitle="Confirm password change"
              dialogNegativeBtnText={t("btnCancel")}
              dialogPositiveBtnText={t("ok")}
              dialogNegativeBtnCall={() => {
                setIsPasswordChange(false);
              }}
              dialogPositiveBtnCall={() => {
                setIsPasswordChange(false);
              }}
              view={<Component.WarningPop iconClassName="ri-lock-2-line" warningMsg={t("passwordChangeWarning")} />}
            />
          ) : null}
          {forgot ? (
            <AppDialog
              setVisibility={(e) => {
                setForgot(e);
              }}
              dialogTitle={t("warning")}
              dialogNegativeBtnText={t("btnCancel")}
              dialogPositiveBtnText={t("btnOkay")}
              dialogPositiveBtnCall={() => {
                forgotPasswordForDoctor();
              }}
              dialogNegativeBtnCall={() => {
                setForgot(false);
              }}
              view={<Component.WarningPop iconClassName="ri-error-warning-line" warningMsg={t("forgotPasswordWarningMsg")} />}
            />
          ) : null}
          {delDoc && (
            <AppDialog
              setVisibility={(e) => {
                setDelDoc(e);
              }}
              dialogTitle={t("delDoc")}
              dialogNegativeBtnText={t("btnCancel")}
              dialogPositiveBtnText={t("btnOkay")}
              dialogPositiveBtnCall={() => {
                delDocPositive();
              }}
              dialogNegativeBtnCall={() => {
                setDelDoc(false);
              }}
              view={<Component.WarningPop iconClassName="ri-error-warning-line" warningMsg={t("areYouSureDelDoc")} />}
            />
          )}

          <div className="screen-name flex-grow-1">
            <div className="manage-doctor-heading-text-adjust-overflow">
              <div className="flex-grow-1 mt-3">
                {isDoctorLogin === false ? (
                  <>
                    <div className="d-flex mt-1">
                      <span
                        className="manage-doctor-profile manage-leave manage-doctor-heading-text-adjust"
                        onClick={() => {
                          nav(strings.navigation.manageDoctor);
                        }}
                      >
                        {t("labelManageDoctor")}
                      </span>
                      <i className="ri-arrow-right-s-line manage manage-leave"></i>
                      <i
                        className="auto ri-arrow-left-s-line more-details-clinic-profile"
                        onClick={() => {
                          nav(strings.navigation.manageDoctor);
                        }}
                      ></i>
                      <span className="text-nowrap manage-doctor-heading-text-adjust">{t("doctorProfile")}</span>
                    </div>
                  </>
                ) : (
                  t("labelProfile")
                )}
              </div>
              <>
                <div className="p-sm-0 p-md-2">
                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <div className="dropdown more-details-clinic-profile">
                      <button className="dropbtn doctor-dropbtn">
                        <i className="ri-more-2-line"></i>
                      </button>
                      <div className="dropdown-content more-details-clinic-profile">
                        <a
                          onClick={() => {
                            setPopup(!popup);
                          }}
                        >
                          {t("labelManageLeave")}
                        </a>
                        {/* <a
                          onClick={() => {
                            nav(utils.strings.navigation.patientList, {
                              state: {
                                doctorId: doctorId,
                              },
                            });
                          }}
                        >
                          {t("viewPatients")}
                        </a> */}
                        <a
                          onClick={() => {
                            setShowEditProfile(true);
                          }}
                        >
                          {t("labelDoctorProfile")}
                        </a>
                        {/* <a
                          onClick={() => {
                            setShowDoctorTiming(true);
                          }}
                        >
                          {t("labelEditTiming")}
                        </a> */}

                        {isDoctorLogin === "false" && authService.getDoctorCount() > 1 && (
                          <a
                            onClick={() => {
                              setDeletedDoctorModal(true);
                            }}
                          >
                            {t("btnDelete")}
                          </a>
                        )}
                        {isDoctorLogin === "true" && (
                          <a
                            onClick={() => {
                              setChangePassword(true);
                            }}
                          >
                            {t("changePassword")}
                          </a>
                        )}
                      </div>
                    </div>
                    <OffCanvas show={showEditProfile} onHide={handleClose} title={t("labelDoctorProfile")}>
                      <EditDocNew onClose={handleClose} doctorInfo={doctorInfo} isLangEn={isLangEn} />
                    </OffCanvas>
                    <OffCanvas show={showDoctorTiming} onHide={handleDoctorTimingClose} title={t("labelDoctorProfile")}>
                      <DoctorTiming isEditTiming={true} isEdited={handleEditDoctorTimingUpdate} doctorId={doctorId} closeTiming={handleDoctorTimingClose} />
                    </OffCanvas>
                  </div>
                  <div className="manage-doctor-heading-buttons manage-leave">
                    {doctorId && isDoctorLogin === false && (
                    <div
                      className="p-2 bd-highlight red"
                      onClick={() => {handleDelDoc()}}
                    >
                      <div
                        className="row mb-2"
                        style={{
                          marginRight: "10px",
                        }}
                      >
                        <button type="button" className="btn btn-outline-danger leave manage-leave align-item-center">
                            <span className="leave text-nowrap">{t("deactivate")}</span>
                        </button>
                      </div>
                    </div>
                    )}
                    
                    <div
                      className="p-2 bd-highlight"
                      onClick={() => {
                        setPopup(!popup);
                      }}
                    >
                      <div
                        className="row mb-2"
                        style={{
                          marginRight: "0px",
                        }}
                      >
                        <button type="button" className="btn btn-outline-danger leave manage-leave align-item-center">
                          <div className="d-md-flex">
                            <i className="ri-calendar-check-line me-1"></i>
                            <span className="leave me-3 text-nowrap">{t("labelManageLeave")}</span>
                          </div>
                        </button>
                      </div>
                    </div>

                    {/* <button
                      type="button"
                      className="btn btn-outline-danger leave manage-leave align-item-center profile-view-patient-btn"
                      onClick={() => {
                        nav(utils.strings.navigation.patientList, {
                          state: {
                            doctorId: doctorId,
                          },
                        });
                      }}
                    >
                      <div className="d-md-flex">
                        <span className="leave me-3 text-nowrap">{t("viewPatients")}</span>
                      </div>
                    </button> */}

                    {doctorId && isDoctorLogin === false ? (
                      <div
                        className="p-2 mb-3"
                        style={{
                          marginRight: "12px",
                        }}
                      >
                        <EditDoctorProfile
                          isClose={handleEditProfileChanges}
                          doctorId={doctorId}
                          isEditDoctorTiming={handleEditDoctorTimingUpdate}
                          doctorInfo={doctorInfo}
                          refresh={refresh}
                          setRefresh={setRefresh}
                          isLangEn={isLangEn}
                        />
                      </div>
                    ) : null}
                    {isDoctorLogin === "true" && (
                      <button
                        type="button"
                        className="btn btn-danger text-white"
                        style={{ whiteSpace: "nowrap" }}
                        onClick={() => {
                          setChangePassword(!changePassword);
                        }}
                      >
                        {t("changePassword")}
                      </button>
                    )}
                    {isDoctorLogin === "false" && authService.getDoctorCount() > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger delete mt-2 text-nowrap"
                        onClick={() => {
                          setDeletedDoctorModal(true);
                        }}
                      >
                        {t("btnDelete")}
                      </button>
                    )}
                  </div>
                </div>
              </>
            </div>

            <div className="view-clinic">
              <div className="doctor-view">
                <div className="row view-clinic-profile">
                  <div className="col-sm-12 col-md-5  col-lg-4 doc-profile-resp ">
                    <ProfileCard doctorInfo={doctorInfo} isLangEn={isLangEn} />
                  </div>
                  <div className="col-sm-12 col-md-7 col-lg-8 view-details">
                    <DoctorProfileDetails randomRefresher={randomRefresherNumber} doctorInfo={doctorInfo} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DoctorProfileView;
